import axios from "axios";
export default {
  name: "wishlistHeaderFriendsSection",
  data() {
    return { userName: "" };
  },
  methods: {
    friendUser() {
      // console.log("test123",this.$store.getters.getUserInfo.friendList);
      // this.$store.getters.getUserInfo.friendList.forEach(element => {
        for(var element of this.$store.getters.getUserInfo.friendList){
        console.log(element._id,this.$route.query.idActive,"basla")
         if(element._id==this.$route.query.idActive){
           return true
         }else{
          return false
         }
      };
      // return true
    },
    getUserInfo() {
      var data = {
        // userId: this.$store.getters.getActiveUser,
        userId:this.$route.query.idActive
      };
      axios
        .post("https://giftstore-blog.herokuapp.com/api/user/getUser", data)
        .then((response) => {
          this.userName =
            response.data.user.firstName + " " + response.data.user.lastName;
        })
        .catch((error) => {
          console.error("There was an error!", error);
        });
      return this.userName;
    },
    deleteFriend() {
      var data = {
        userId: window.localStorage.getItem("Giftstore-U"),
        friendId: this.$route.query.idActive,
      };
      axios
        .post(
          "https://giftstore-blog.herokuapp.com/api/user/friend/delete",
          data
        )
        .then((response) => {
          this.$toast.open({
            message: "ami bien supprimer",
            type: "success",
            // all of other options may go here
          });
        })
        .catch((error) => {
          console.error("There was an error!", error);
        });
    },
    addUserFriend() {
      var data = {
        userId: window.localStorage.getItem("Giftstore-U"),
        friendId: this.$route.query.idActive,
      };
      axios
        .post("https://giftstore-blog.herokuapp.com/api/user/friend/add", data)
        .then((response) => {
          // this.getUsers();
          this.$toast.open({
            message: "ami bien ajouté",
            type: "success",
            // all of other options may go here
          });
        })
        .catch((error) => {
          console.error("There was an error!", error);
        });
    },
  },
};
